<div fxLayout="row" fxLayoutGap="5px">
    <div>
        <form [formGroup]="PrijscorrectieFormGroup">
            <br>
            <mat-card class="dashboard-card">
                <mat-card-header>
                    <mat-card-title>Prijscorrectie</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <br>
                    <mg-simple-form-section title="Instrumenten">
                        <mg-simple-form-row>
                            <span mg-colspan-3>          
                                <mat-form-field pd-size-22>
                                    <mg-autocomplete #soortIDAutocomplete placeholder="Soort" formControlName="soortID" [getData]="getSoortIDDataSource"></mg-autocomplete>
                                </mat-form-field>
                                &nbsp;
                                <mat-form-field pd-size-22>
                                    <mg-autocomplete #merkIDAutocomplete placeholder="Merk" formControlName="merkID" [getData]="getMerkIDDataSource"></mg-autocomplete>
                                </mat-form-field>
                            </span>
                        </mg-simple-form-row>
                        <mg-simple-form-row>
                            <span>
                                <mat-slide-toggle color="accent" formControlName="alles">Alle Instrumenten</mat-slide-toggle>
                            </span>
                        </mg-simple-form-row>
                    </mg-simple-form-section>
                    <mg-simple-form-section title="Prijzen">
                      <mg-simple-form-row>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Standaard" matInput formControlName="prijsStd">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage CIJ+" matInput formControlName="prijsCY">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage RvA" matInput formControlName="prijsRvA">
                          </mat-form-field>
                        </span>
                      </mg-simple-form-row>
                      <mg-simple-form-row>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage NEN3140" matInput formControlName="prijsNen">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Keuring" matInput formControlName="prijsKeuring">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage BRL100" matInput formControlName="prijsBrl100">
                          </mat-form-field>
                        </span>
                      </mg-simple-form-row>
                      <mg-simple-form-row>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage CrossCheck" matInput formControlName="prijsCrossCheck">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Scios" matInput formControlName="prijsScios">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage BRL6010" matInput formControlName="prijsBRL6010">
                          </mat-form-field>
                        </span>
                      </mg-simple-form-row>
                      <mg-simple-form-row>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Pool Binnen" matInput formControlName="prijsPool">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Pool Buiten" matInput formControlName="prijsPoolBuiten">
                          </mat-form-field>
                        </span>
                      </mg-simple-form-row>
                      <mg-simple-form-row>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Kwestie Binnen" matInput formControlName="prijsKwestie">
                          </mat-form-field>
                        </span>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage Kwestie Buiten" matInput formControlName="prijsKwestieBuiten">
                          </mat-form-field>
                        </span>
                      </mg-simple-form-row>
                    </mg-simple-form-section>
                    <br>
                    <div class="button">
                        <button mat-button (click)="this.Prijscorrectie()">Start Prijscorrectie</button>
                    </div>
                    <br>                    
                </mat-card-content>
            </mat-card>
        </form>

    </div>    
</div>
